__webpack_require__.p = "https://design-services.platform.99cluster.com/design/_next/";